import type { ProjectCapability, ProjectView } from "@esi/shared";

/**
 * Whether the caller may take an action in `project`, from the capabilities the server computed
 * for their role (`ProjectView.capabilities`). The SPA never compares roles: every action it
 * offers goes through this one check, and the server stays the authority.
 */
export function can(project: Pick<ProjectView, "capabilities">, capability: ProjectCapability) {
  return project.capabilities.includes(capability);
}

/** Like {@link can}, for an action that changes the project: never while it is frozen. */
export function canChange(
  project: Pick<ProjectView, "capabilities" | "frozenAt">,
  capability: ProjectCapability,
) {
  return project.frozenAt === null && can(project, capability);
}
